// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"color-picker_colorPopup__tB9u3","dark":"color-picker_dark__I2XJ5","light":"color-picker_light__OulRC"};